"use client"

export const AboutCertifications = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16 animate-in fade-in duration-700">
          <div className="inline-flex items-center gap-2 bg-orange-100 text-orange-700 px-4 py-2 rounded-full text-sm mb-4 font-semibold shadow-sm">
            <span className="w-2 h-2 bg-orange-500 rounded-full"></span>
            Trusted & Certified
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">Certifications & Accreditations</h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-lg">
            We are proud to be accredited by leading travel and tourism organizations
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 lg:gap-12 items-center justify-items-center">
          <div className="flex flex-col items-center group animate-in fade-in duration-700 transform hover:scale-105 transition-transform duration-300" style={{ animationDelay: '100ms' }}>
            <img src="/IATA.png" alt="IATA" className="h-30 w-auto object-contain" loading="lazy" />
          </div>
          <div className="flex flex-col items-center group animate-in fade-in duration-700 transform hover:scale-105 transition-transform duration-300" style={{ animationDelay: '200ms' }}>
            <img src="/DOT.png" alt="Department of Tourism" className="h-30 w-auto object-contain" loading="lazy" />
          </div>
          <div className="flex flex-col items-center group animate-in fade-in duration-700 transform hover:scale-105 transition-transform duration-300" style={{ animationDelay: '300ms' }}>
            <img src="/PTAA.png" alt="PTAA" className="h-14 w-auto object-contain filter drop-shadow-[0_0_6px_rgba(255,255,255,0.55)]" loading="lazy" />
          </div>
          <div className="flex flex-col items-center group animate-in fade-in duration-700 transform hover:scale-105 transition-transform duration-300" style={{ animationDelay: '400ms' }}>
            <img src="/TPB.png" alt="Tourism Promotions Board" className="h-14 w-auto object-contain" loading="lazy" />
          </div>
          <div className="flex flex-col items-center group animate-in fade-in duration-700 transform hover:scale-105 transition-transform duration-300" style={{ animationDelay: '500ms' }}>
            <img src="/PHILTOA.png" alt="PHILTOA" className="h-20 w-auto object-contain" loading="lazy" />
          </div>
        </div>
      </div>
    </section>
  )
}
